import React from "react";

const PropertyRecentSearch = () => {
  return (
    <span style={{ background: "#E1EAF2", padding: "8px 10px", borderRadius: 12 }}>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="18"
        height="18"
        viewBox="0 0 18 18"
      >
        <path
          fill="#2A69A3"
          fill-rule="evenodd"
          d="M9 0c4.97 0 9 4.03 9 9s-4.03 9-9 9-9-4.03-9-9 4.03-9 9-9zm0 1.8C5.024 1.8 1.8 5.024 1.8 9s3.224 7.2 7.2 7.2 7.2-3.224 7.2-7.2S12.976 1.8 9 1.8zm.9 2.611c.462 0 .842.348.894.795l.006.105V10.8H5.4c-.497 0-.9-.403-.9-.9 0-.462.347-.842.795-.894L5.4 9H9V5.311c0-.461.347-.842.795-.894l.105-.006z"
        ></path>
      </svg>
    </span>
  );
};

export default PropertyRecentSearch;
